"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiatCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _useContextSelector = require("use-context-selector");
var _FiatServiceFee = require("./FiatServiceFee");
var _Card = require("./Card");
var _page = require("../page");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FiatCard = function FiatCard() {
  var ticker = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.ticker;
  });
  return /*#__PURE__*/_react.default.createElement(_Card.Card, {
    serviceFee: /*#__PURE__*/_react.default.createElement(_FiatServiceFee.FiatServiceFee, {
      ticker: ticker
    })
  });
};
exports.FiatCard = FiatCard;